!function (e, r) {
  "object" == typeof exports && "object" == typeof module ? module.exports = r(require("react")) : "function" == typeof define && define.amd ? define(["react"], r) : "object" == typeof exports ? exports.Skeleton = r(require("react")) : e.Skeleton = r(e._);
}(window, function (e) {
  return function (e) {
    var r = {};

    function t(n) {
      if (r[n]) return r[n].exports;
      var a = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(a.exports, a, a.exports, t), a.l = !0, a.exports;
    }

    return t.m = e, t.c = r, t.d = function (e, r, n) {
      t.o(e, r) || Object.defineProperty(e, r, {
        enumerable: !0,
        get: n
      });
    }, t.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, t.t = function (e, r) {
      if (1 & r && (e = t(e)), 8 & r) return e;
      if (4 & r && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (t.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & r && "string" != typeof e) for (var a in e) {
        t.d(n, a, function (r) {
          return e[r];
        }.bind(null, a));
      }
      return n;
    }, t.n = function (e) {
      var r = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(r, "a", r), r;
    }, t.o = function (e, r) {
      return Object.prototype.hasOwnProperty.call(e, r);
    }, t.p = "", t(t.s = 1);
  }([function (r, t) {
    r.exports = e;
  }, function (e, r, t) {
    e.exports = t(2);
  }, function (e, r, t) {
    "use strict";

    t.r(r);
    var n = t(0),
        a = t.n(n);

    var i = function () {
      function e(e) {
        this.isSpeedy = void 0 === e.speedy || e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.before = null;
      }

      var r = e.prototype;
      return r.insert = function (e) {
        if (this.ctr % (this.isSpeedy ? 65e3 : 1) == 0) {
          var r,
              t = function (e) {
            var r = document.createElement("style");
            return r.setAttribute("data-emotion", e.key), void 0 !== e.nonce && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r;
          }(this);

          r = 0 === this.tags.length ? this.before : this.tags[this.tags.length - 1].nextSibling, this.container.insertBefore(t, r), this.tags.push(t);
        }

        var n = this.tags[this.tags.length - 1];

        if (this.isSpeedy) {
          var a = function (e) {
            if (e.sheet) return e.sheet;

            for (var r = 0; r < document.styleSheets.length; r++) {
              if (document.styleSheets[r].ownerNode === e) return document.styleSheets[r];
            }
          }(n);

          try {
            var i = 105 === e.charCodeAt(1) && 64 === e.charCodeAt(0);
            a.insertRule(e, i ? 0 : a.cssRules.length);
          } catch (e) {
            0;
          }
        } else n.appendChild(document.createTextNode(e));

        this.ctr++;
      }, r.flush = function () {
        this.tags.forEach(function (e) {
          return e.parentNode.removeChild(e);
        }), this.tags = [], this.ctr = 0;
      }, e;
    }();

    var c = function c(e) {
      function r(e, r, n) {
        var a = r.trim().split(b);
        r = a;
        var i = a.length,
            c = e.length;

        switch (c) {
          case 0:
          case 1:
            var o = 0;

            for (e = 0 === c ? "" : e[0] + " "; o < i; ++o) {
              r[o] = t(e, r[o], n).trim();
            }

            break;

          default:
            var s = o = 0;

            for (r = []; o < i; ++o) {
              for (var u = 0; u < c; ++u) {
                r[s++] = t(e[u] + " ", a[o], n).trim();
              }
            }

        }

        return r;
      }

      function t(e, r, t) {
        var n = r.charCodeAt(0);

        switch (33 > n && (n = (r = r.trim()).charCodeAt(0)), n) {
          case 38:
            return r.replace(p, "$1" + e.trim());

          case 58:
            return e.trim() + r.replace(p, "$1" + e.trim());

          default:
            if (0 < 1 * t && 0 < r.indexOf("\f")) return r.replace(p, (58 === e.charCodeAt(0) ? "" : "$1") + e.trim());
        }

        return e + r;
      }

      function n(e, r, t, i) {
        var c = e + ";",
            o = 2 * r + 3 * t + 4 * i;

        if (944 === o) {
          e = c.indexOf(":", 9) + 1;
          var s = c.substring(e, c.length - 1).trim();
          return s = c.substring(0, e).trim() + s + ";", 1 === E || 2 === E && a(s, 1) ? "-webkit-" + s + s : s;
        }

        if (0 === E || 2 === E && !a(c, 1)) return c;

        switch (o) {
          case 1015:
            return 97 === c.charCodeAt(10) ? "-webkit-" + c + c : c;

          case 951:
            return 116 === c.charCodeAt(3) ? "-webkit-" + c + c : c;

          case 963:
            return 110 === c.charCodeAt(5) ? "-webkit-" + c + c : c;

          case 1009:
            if (100 !== c.charCodeAt(4)) break;

          case 969:
          case 942:
            return "-webkit-" + c + c;

          case 978:
            return "-webkit-" + c + "-moz-" + c + c;

          case 1019:
          case 983:
            return "-webkit-" + c + "-moz-" + c + "-ms-" + c + c;

          case 883:
            if (45 === c.charCodeAt(8)) return "-webkit-" + c + c;
            if (0 < c.indexOf("image-set(", 11)) return c.replace(O, "$1-webkit-$2") + c;
            break;

          case 932:
            if (45 === c.charCodeAt(4)) switch (c.charCodeAt(5)) {
              case 103:
                return "-webkit-box-" + c.replace("-grow", "") + "-webkit-" + c + "-ms-" + c.replace("grow", "positive") + c;

              case 115:
                return "-webkit-" + c + "-ms-" + c.replace("shrink", "negative") + c;

              case 98:
                return "-webkit-" + c + "-ms-" + c.replace("basis", "preferred-size") + c;
            }
            return "-webkit-" + c + "-ms-" + c + c;

          case 964:
            return "-webkit-" + c + "-ms-flex-" + c + c;

          case 1023:
            if (99 !== c.charCodeAt(8)) break;
            return "-webkit-box-pack" + (s = c.substring(c.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify")) + "-webkit-" + c + "-ms-flex-pack" + s + c;

          case 1005:
            return d.test(c) ? c.replace(f, ":-webkit-") + c.replace(f, ":-moz-") + c : c;

          case 1e3:
            switch (r = (s = c.substring(13).trim()).indexOf("-") + 1, s.charCodeAt(0) + s.charCodeAt(r)) {
              case 226:
                s = c.replace(k, "tb");
                break;

              case 232:
                s = c.replace(k, "tb-rl");
                break;

              case 220:
                s = c.replace(k, "lr");
                break;

              default:
                return c;
            }

            return "-webkit-" + c + "-ms-" + s + c;

          case 1017:
            if (-1 === c.indexOf("sticky", 9)) break;

          case 975:
            switch (r = (c = e).length - 10, o = (s = (33 === c.charCodeAt(r) ? c.substring(0, r) : c).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | s.charCodeAt(7))) {
              case 203:
                if (111 > s.charCodeAt(8)) break;

              case 115:
                c = c.replace(s, "-webkit-" + s) + ";" + c;
                break;

              case 207:
              case 102:
                c = c.replace(s, "-webkit-" + (102 < o ? "inline-" : "") + "box") + ";" + c.replace(s, "-webkit-" + s) + ";" + c.replace(s, "-ms-" + s + "box") + ";" + c;
            }

            return c + ";";

          case 938:
            if (45 === c.charCodeAt(5)) switch (c.charCodeAt(6)) {
              case 105:
                return s = c.replace("-items", ""), "-webkit-" + c + "-webkit-box-" + s + "-ms-flex-" + s + c;

              case 115:
                return "-webkit-" + c + "-ms-flex-item-" + c.replace(A, "") + c;

              default:
                return "-webkit-" + c + "-ms-flex-line-pack" + c.replace("align-content", "").replace(A, "") + c;
            }
            break;

          case 973:
          case 989:
            if (45 !== c.charCodeAt(3) || 122 === c.charCodeAt(4)) break;

          case 931:
          case 953:
            if (!0 === x.test(e)) return 115 === (s = e.substring(e.indexOf(":") + 1)).charCodeAt(0) ? n(e.replace("stretch", "fill-available"), r, t, i).replace(":fill-available", ":stretch") : c.replace(s, "-webkit-" + s) + c.replace(s, "-moz-" + s.replace("fill-", "")) + c;
            break;

          case 962:
            if (c = "-webkit-" + c + (102 === c.charCodeAt(5) ? "-ms-" + c : "") + c, 211 === t + i && 105 === c.charCodeAt(13) && 0 < c.indexOf("transform", 10)) return c.substring(0, c.indexOf(";", 27) + 1).replace(h, "$1-webkit-$2") + c;
        }

        return c;
      }

      function a(e, r) {
        var t = e.indexOf(1 === r ? ":" : "{"),
            n = e.substring(0, 3 !== r ? t : 10);
        return t = e.substring(t + 1, e.length - 1), R(2 !== r ? n : n.replace(C, "$1"), t, r);
      }

      function i(e, r) {
        var t = n(r, r.charCodeAt(0), r.charCodeAt(1), r.charCodeAt(2));
        return t !== r + ";" ? t.replace(w, " or ($1)").substring(4) : "(" + r + ")";
      }

      function c(e, r, t, n, a, i, c, o, u, l) {
        for (var f, d = 0, h = r; d < $; ++d) {
          switch (f = z[d].call(s, e, h, t, n, a, i, c, o, u, l)) {
            case void 0:
            case !1:
            case !0:
            case null:
              break;

            default:
              h = f;
          }
        }

        if (h !== r) return h;
      }

      function o(e) {
        return void 0 !== (e = e.prefix) && (R = null, e ? "function" != typeof e ? E = 1 : (E = 2, R = e) : E = 0), o;
      }

      function s(e, t) {
        var o = e;

        if (33 > o.charCodeAt(0) && (o = o.trim()), o = [o], 0 < $) {
          var s = c(-1, t, o, o, j, S, 0, 0, 0, 0);
          void 0 !== s && "string" == typeof s && (t = s);
        }

        var f = function e(t, o, s, f, d) {
          for (var h, b, p, k, w, A = 0, C = 0, x = 0, O = 0, z = 0, R = 0, G = p = h = 0, M = 0, T = 0, I = 0, W = 0, q = s.length, D = q - 1, F = "", L = "", B = "", H = ""; M < q;) {
            if (b = s.charCodeAt(M), M === D && 0 !== C + O + x + A && (0 !== C && (b = 47 === C ? 10 : 47), O = x = A = 0, q++, D++), 0 === C + O + x + A) {
              if (M === D && (0 < T && (F = F.replace(l, "")), 0 < F.trim().length)) {
                switch (b) {
                  case 32:
                  case 9:
                  case 59:
                  case 13:
                  case 10:
                    break;

                  default:
                    F += s.charAt(M);
                }

                b = 59;
              }

              switch (b) {
                case 123:
                  for (h = (F = F.trim()).charCodeAt(0), p = 1, W = ++M; M < q;) {
                    switch (b = s.charCodeAt(M)) {
                      case 123:
                        p++;
                        break;

                      case 125:
                        p--;
                        break;

                      case 47:
                        switch (b = s.charCodeAt(M + 1)) {
                          case 42:
                          case 47:
                            e: {
                              for (G = M + 1; G < D; ++G) {
                                switch (s.charCodeAt(G)) {
                                  case 47:
                                    if (42 === b && 42 === s.charCodeAt(G - 1) && M + 2 !== G) {
                                      M = G + 1;
                                      break e;
                                    }

                                    break;

                                  case 10:
                                    if (47 === b) {
                                      M = G + 1;
                                      break e;
                                    }

                                }
                              }

                              M = G;
                            }

                        }

                        break;

                      case 91:
                        b++;

                      case 40:
                        b++;

                      case 34:
                      case 39:
                        for (; M++ < D && s.charCodeAt(M) !== b;) {
                          ;
                        }

                    }

                    if (0 === p) break;
                    M++;
                  }

                  switch (p = s.substring(W, M), 0 === h && (h = (F = F.replace(u, "").trim()).charCodeAt(0)), h) {
                    case 64:
                      switch (0 < T && (F = F.replace(l, "")), b = F.charCodeAt(1)) {
                        case 100:
                        case 109:
                        case 115:
                        case 45:
                          T = o;
                          break;

                        default:
                          T = P;
                      }

                      if (W = (p = e(o, T, p, b, d + 1)).length, 0 < $ && (w = c(3, p, T = r(P, F, I), o, j, S, W, b, d, f), F = T.join(""), void 0 !== w && 0 === (W = (p = w.trim()).length) && (b = 0, p = "")), 0 < W) switch (b) {
                        case 115:
                          F = F.replace(y, i);

                        case 100:
                        case 109:
                        case 45:
                          p = F + "{" + p + "}";
                          break;

                        case 107:
                          p = (F = F.replace(g, "$1 $2")) + "{" + p + "}", p = 1 === E || 2 === E && a("@" + p, 3) ? "@-webkit-" + p + "@" + p : "@" + p;
                          break;

                        default:
                          p = F + p, 112 === f && (L += p, p = "");
                      } else p = "";
                      break;

                    default:
                      p = e(o, r(o, F, I), p, f, d + 1);
                  }

                  B += p, p = I = T = G = h = 0, F = "", b = s.charCodeAt(++M);
                  break;

                case 125:
                case 59:
                  if (1 < (W = (F = (0 < T ? F.replace(l, "") : F).trim()).length)) switch (0 === G && (h = F.charCodeAt(0), 45 === h || 96 < h && 123 > h) && (W = (F = F.replace(" ", ":")).length), 0 < $ && void 0 !== (w = c(1, F, o, t, j, S, L.length, f, d, f)) && 0 === (W = (F = w.trim()).length) && (F = "\0\0"), h = F.charCodeAt(0), b = F.charCodeAt(1), h) {
                    case 0:
                      break;

                    case 64:
                      if (105 === b || 99 === b) {
                        H += F + s.charAt(M);
                        break;
                      }

                    default:
                      58 !== F.charCodeAt(W - 1) && (L += n(F, h, b, F.charCodeAt(2)));
                  }
                  I = T = G = h = 0, F = "", b = s.charCodeAt(++M);
              }
            }

            switch (b) {
              case 13:
              case 10:
                47 === C ? C = 0 : 0 === 1 + h && 107 !== f && 0 < F.length && (T = 1, F += "\0"), 0 < $ * N && c(0, F, o, t, j, S, L.length, f, d, f), S = 1, j++;
                break;

              case 59:
              case 125:
                if (0 === C + O + x + A) {
                  S++;
                  break;
                }

              default:
                switch (S++, k = s.charAt(M), b) {
                  case 9:
                  case 32:
                    if (0 === O + A + C) switch (z) {
                      case 44:
                      case 58:
                      case 9:
                      case 32:
                        k = "";
                        break;

                      default:
                        32 !== b && (k = " ");
                    }
                    break;

                  case 0:
                    k = "\\0";
                    break;

                  case 12:
                    k = "\\f";
                    break;

                  case 11:
                    k = "\\v";
                    break;

                  case 38:
                    0 === O + C + A && (T = I = 1, k = "\f" + k);
                    break;

                  case 108:
                    if (0 === O + C + A + _ && 0 < G) switch (M - G) {
                      case 2:
                        112 === z && 58 === s.charCodeAt(M - 3) && (_ = z);

                      case 8:
                        111 === R && (_ = R);
                    }
                    break;

                  case 58:
                    0 === O + C + A && (G = M);
                    break;

                  case 44:
                    0 === C + x + O + A && (T = 1, k += "\r");
                    break;

                  case 34:
                  case 39:
                    0 === C && (O = O === b ? 0 : 0 === O ? b : O);
                    break;

                  case 91:
                    0 === O + C + x && A++;
                    break;

                  case 93:
                    0 === O + C + x && A--;
                    break;

                  case 41:
                    0 === O + C + A && x--;
                    break;

                  case 40:
                    if (0 === O + C + A) {
                      if (0 === h) switch (2 * z + 3 * R) {
                        case 533:
                          break;

                        default:
                          h = 1;
                      }
                      x++;
                    }

                    break;

                  case 64:
                    0 === C + x + O + A + G + p && (p = 1);
                    break;

                  case 42:
                  case 47:
                    if (!(0 < O + A + x)) switch (C) {
                      case 0:
                        switch (2 * b + 3 * s.charCodeAt(M + 1)) {
                          case 235:
                            C = 47;
                            break;

                          case 220:
                            W = M, C = 42;
                        }

                        break;

                      case 42:
                        47 === b && 42 === z && W + 2 !== M && (33 === s.charCodeAt(W + 2) && (L += s.substring(W, M + 1)), k = "", C = 0);
                    }
                }

                0 === C && (F += k);
            }

            R = z, z = b, M++;
          }

          if (0 < (W = L.length)) {
            if (T = o, 0 < $ && void 0 !== (w = c(2, L, T, t, j, S, W, f, d, f)) && 0 === (L = w).length) return H + L + B;

            if (L = T.join(",") + "{" + L + "}", 0 != E * _) {
              switch (2 !== E || a(L, 2) || (_ = 0), _) {
                case 111:
                  L = L.replace(v, ":-moz-$1") + L;
                  break;

                case 112:
                  L = L.replace(m, "::-webkit-input-$1") + L.replace(m, "::-moz-$1") + L.replace(m, ":-ms-input-$1") + L;
              }

              _ = 0;
            }
          }

          return H + L + B;
        }(P, o, t, 0, 0);

        return 0 < $ && void 0 !== (s = c(-2, f, o, o, j, S, f.length, 0, 0, 0)) && (f = s), "", _ = 0, S = j = 1, f;
      }

      var u = /^\0+/g,
          l = /[\0\r\f]/g,
          f = /: */g,
          d = /zoo|gra/,
          h = /([,: ])(transform)/g,
          b = /,\r+?/g,
          p = /([\t\r\n ])*\f?&/g,
          g = /@(k\w+)\s*(\S*)\s*/,
          m = /::(place)/g,
          v = /:(read-only)/g,
          k = /[svh]\w+-[tblr]{2}/,
          y = /\(\s*(.*)\s*\)/g,
          w = /([\s\S]*?);/g,
          A = /-self|flex-/g,
          C = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
          x = /stretch|:\s*\w+\-(?:conte|avail)/,
          O = /([^-])(image-set\()/,
          S = 1,
          j = 1,
          _ = 0,
          E = 1,
          P = [],
          z = [],
          $ = 0,
          R = null,
          N = 0;
      return s.use = function e(r) {
        switch (r) {
          case void 0:
          case null:
            $ = z.length = 0;
            break;

          default:
            if ("function" == typeof r) z[$++] = r;else if ("object" == typeof r) for (var t = 0, n = r.length; t < n; ++t) {
              e(r[t]);
            } else N = 0 | !!r;
        }

        return e;
      }, s.set = o, void 0 !== e && o(e), s;
    };

    function o(e) {
      e && s.current.insert(e + "}");
    }

    var s = {
      current: null
    },
        u = function u(e, r, t, n, a, i, c, _u, l, f) {
      switch (e) {
        case 1:
          switch (r.charCodeAt(0)) {
            case 64:
              return s.current.insert(r + ";"), "";

            case 108:
              if (98 === r.charCodeAt(2)) return "";
          }

          break;

        case 2:
          if (0 === _u) return r + "/*|*/";
          break;

        case 3:
          switch (_u) {
            case 102:
            case 112:
              return s.current.insert(t[0] + r), "";

            default:
              return r + (0 === f ? "/*|*/" : "");
          }

        case -2:
          r.split("/*|*/}").forEach(o);
      }
    },
        l = function l(e) {
      void 0 === e && (e = {});
      var r,
          t = e.key || "css";
      void 0 !== e.prefix && (r = {
        prefix: e.prefix
      });
      var n = new c(r);
      var a,
          o = {};
      a = e.container || document.head;
      var l,
          f = document.querySelectorAll("style[data-emotion-" + t + "]");
      Array.prototype.forEach.call(f, function (e) {
        e.getAttribute("data-emotion-" + t).split(" ").forEach(function (e) {
          o[e] = !0;
        }), e.parentNode !== a && a.appendChild(e);
      }), n.use(e.stylisPlugins)(u), l = function l(e, r, t, a) {
        var i = r.name;
        s.current = t, n(e, r.styles), a && (d.inserted[i] = !0);
      };
      var d = {
        key: t,
        sheet: new i({
          key: t,
          container: a,
          nonce: e.nonce,
          speedy: e.speedy
        }),
        nonce: e.nonce,
        inserted: o,
        registered: {},
        insert: l
      };
      return d;
    };

    var f = function f(e) {
      for (var r, t = e.length, n = t ^ t, a = 0; t >= 4;) {
        r = 1540483477 * (65535 & (r = 255 & e.charCodeAt(a) | (255 & e.charCodeAt(++a)) << 8 | (255 & e.charCodeAt(++a)) << 16 | (255 & e.charCodeAt(++a)) << 24)) + ((1540483477 * (r >>> 16) & 65535) << 16), n = 1540483477 * (65535 & n) + ((1540483477 * (n >>> 16) & 65535) << 16) ^ (r = 1540483477 * (65535 & (r ^= r >>> 24)) + ((1540483477 * (r >>> 16) & 65535) << 16)), t -= 4, ++a;
      }

      switch (t) {
        case 3:
          n ^= (255 & e.charCodeAt(a + 2)) << 16;

        case 2:
          n ^= (255 & e.charCodeAt(a + 1)) << 8;

        case 1:
          n = 1540483477 * (65535 & (n ^= 255 & e.charCodeAt(a))) + ((1540483477 * (n >>> 16) & 65535) << 16);
      }

      return n = 1540483477 * (65535 & (n ^= n >>> 13)) + ((1540483477 * (n >>> 16) & 65535) << 16), ((n ^= n >>> 15) >>> 0).toString(36);
    },
        d = {
      animationIterationCount: 1,
      borderImageOutset: 1,
      borderImageSlice: 1,
      borderImageWidth: 1,
      boxFlex: 1,
      boxFlexGroup: 1,
      boxOrdinalGroup: 1,
      columnCount: 1,
      columns: 1,
      flex: 1,
      flexGrow: 1,
      flexPositive: 1,
      flexShrink: 1,
      flexNegative: 1,
      flexOrder: 1,
      gridRow: 1,
      gridRowEnd: 1,
      gridRowSpan: 1,
      gridRowStart: 1,
      gridColumn: 1,
      gridColumnEnd: 1,
      gridColumnSpan: 1,
      gridColumnStart: 1,
      msGridRow: 1,
      msGridRowSpan: 1,
      msGridColumn: 1,
      msGridColumnSpan: 1,
      fontWeight: 1,
      lineHeight: 1,
      opacity: 1,
      order: 1,
      orphans: 1,
      tabSize: 1,
      widows: 1,
      zIndex: 1,
      zoom: 1,
      WebkitLineClamp: 1,
      fillOpacity: 1,
      floodOpacity: 1,
      stopOpacity: 1,
      strokeDasharray: 1,
      strokeDashoffset: 1,
      strokeMiterlimit: 1,
      strokeOpacity: 1,
      strokeWidth: 1
    };

    var h = /[A-Z]|^ms/g,
        b = /_EMO_([^_]+?)_([^]*?)_EMO_/g,
        p = function p(e) {
      return 45 === e.charCodeAt(1);
    },
        g = function (e) {
      var r = {};
      return function (t) {
        return void 0 === r[t] && (r[t] = e(t)), r[t];
      };
    }(function (e) {
      return p(e) ? e : e.replace(h, "-$&").toLowerCase();
    }),
        m = function m(e, r) {
      if (null == r || "boolean" == typeof r) return "";

      switch (e) {
        case "animation":
        case "animationName":
          if ("string" == typeof r) return r.replace(b, function (e, r, t) {
            return k = {
              name: r,
              styles: t,
              next: k
            }, r;
          });
      }

      return 1 === d[e] || p(e) || "number" != typeof r || 0 === r ? r : r + "px";
    };

    function v(e, r, t, n) {
      if (null == t) return "";
      if (void 0 !== t.__emotion_styles) return t;

      switch (typeof t) {
        case "boolean":
          return "";

        case "object":
          if (1 === t.anim) return k = {
            name: t.name,
            styles: t.styles,
            next: k
          }, t.name;

          if (void 0 !== t.styles) {
            var a = t.next;
            if (void 0 !== a) for (; void 0 !== a;) {
              k = {
                name: a.name,
                styles: a.styles,
                next: k
              }, a = a.next;
            }
            return t.styles;
          }

          return function (e, r, t) {
            var n = "";
            if (Array.isArray(t)) for (var a = 0; a < t.length; a++) {
              n += v(e, r, t[a], !1);
            } else for (var i in t) {
              var c = t[i];
              if ("object" != typeof c) null != r && void 0 !== r[c] ? n += i + "{" + r[c] + "}" : n += g(i) + ":" + m(i, c) + ";";else if (!Array.isArray(c) || "string" != typeof c[0] || null != r && void 0 !== r[c[0]]) {
                var o = v(e, r, c, !1);

                switch (i) {
                  case "animation":
                  case "animationName":
                    n += g(i) + ":" + o + ";";
                    break;

                  default:
                    n += i + "{" + o + "}";
                }
              } else for (var s = 0; s < c.length; s++) {
                n += g(i) + ":" + m(i, c[s]) + ";";
              }
            }
            return n;
          }(e, r, t);

        case "function":
          if (void 0 !== e) {
            var i = k,
                c = t(e);
            return k = i, v(e, r, c, n);
          }

        default:
          if (null == r) return t;
          var o = r[t];
          return void 0 === o || n ? t : o;
      }
    }

    var k,
        y = /label:\s*([^\s;\n{]+)\s*;/g;

    var w = function w(e, r, t) {
      if (1 === e.length && "object" == typeof e[0] && null !== e[0] && void 0 !== e[0].styles) return e[0];
      var n = !0,
          a = "";
      k = void 0;
      var i = e[0];
      null == i || void 0 === i.raw ? (n = !1, a += v(t, r, i, !1)) : a += i[0];

      for (var c = 1; c < e.length; c++) {
        a += v(t, r, e[c], 46 === a.charCodeAt(a.length - 1)), n && (a += i[c]);
      }

      y.lastIndex = 0;

      for (var o, s = ""; null !== (o = y.exec(a));) {
        s += "-" + o[1];
      }

      return {
        name: f(a) + s,
        styles: a,
        next: k
      };
    };

    function A(e, r, t) {
      var n = "";
      return t.split(" ").forEach(function (t) {
        void 0 !== e[t] ? r.push(e[t]) : n += t + " ";
      }), n;
    }

    var C = function C(e, r, t) {
      var n = e.key + "-" + r.name;

      if (!1 === t && void 0 === e.registered[n] && (e.registered[n] = r.styles), void 0 === e.inserted[r.name]) {
        var a = r;

        do {
          e.insert("." + n, a, e.sheet, !0);
          a = a.next;
        } while (void 0 !== a);
      }
    };

    function x(e, r) {
      if (void 0 === e.inserted[r.name]) return e.insert("", r, e.sheet, !0);
    }

    function O(e, r, t) {
      var n = [],
          a = A(e, n, t);
      return n.length < 2 ? t : a + r(n);
    }

    var S = function e(r) {
      for (var t = "", n = 0; n < r.length; n++) {
        var a = r[n];

        if (null != a) {
          var i = void 0;

          switch (typeof a) {
            case "boolean":
              break;

            case "object":
              if (Array.isArray(a)) i = e(a);else for (var c in i = "", a) {
                a[c] && c && (i && (i += " "), i += c);
              }
              break;

            default:
              i = a;
          }

          i && (t && (t += " "), t += i);
        }
      }

      return t;
    },
        j = function (e) {
      var r = l(e);
      r.sheet.speedy = function (e) {
        this.isSpeedy = e;
      }, r.compat = !0;

      var t = function t() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        var a = w(t, r.registered, void 0 !== this ? this.mergedProps : void 0);
        return C(r, a, !1), r.key + "-" + a.name;
      };

      return {
        css: t,
        cx: function cx() {
          for (var e = arguments.length, n = new Array(e), a = 0; a < e; a++) {
            n[a] = arguments[a];
          }

          return O(r.registered, t, S(n));
        },
        injectGlobal: function injectGlobal() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
            t[n] = arguments[n];
          }

          var a = w(t, r.registered);
          x(r, a);
        },
        keyframes: function keyframes() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
            t[n] = arguments[n];
          }

          var a = w(t, r.registered),
              i = "animation-" + a.name;
          return x(r, {
            name: a.name,
            styles: "@keyframes " + i + "{" + a.styles + "}"
          }), i;
        },
        hydrate: function hydrate(e) {
          e.forEach(function (e) {
            r.inserted[e] = !0;
          });
        },
        flush: function flush() {
          r.registered = {}, r.inserted = {}, r.sheet.flush();
        },
        sheet: r.sheet,
        cache: r,
        getRegisteredStyles: A.bind(null, r.registered),
        merge: O.bind(null, r.registered, t)
      };
    }(),
        _ = (j.flush, j.hydrate, j.cx, j.merge, j.getRegisteredStyles, j.injectGlobal, j.keyframes),
        E = j.css;

    j.sheet, j.cache;

    function P() {
      var e = $(["\n  background-color: ", ";\n  background-image: linear-gradient(\n    90deg,\n    ", ",\n    ", ",\n    ", "\n  );\n  background-size: 200px 100%;\n  background-repeat: no-repeat;\n  border-radius: 4px;\n  display: inline-block;\n  line-height: 1;\n  width: 100%;\n"]);
      return P = function P() {
        return e;
      }, e;
    }

    function z() {
      var e = $(["\n  0% {\n    background-position: -200px 0;\n  }\n  100% {\n    background-position: calc(200px + 100%) 0;\n  }\n"]);
      return z = function z() {
        return e;
      }, e;
    }

    function $(e, r) {
      return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(r)
        }
      }));
    }

    var R = _(z()),
        N = E(P(), "#eee", "#eee", "#f5f5f5", "#eee");

    function G(e) {
      for (var r = e.count, t = e.duration, n = e.width, i = e.wrapper, c = e.height, o = e.circle, s = [], u = 0; u < r; u++) {
        var l = {
          animation: "".concat(R, " ") + String(t) + "s ease-in-out infinite"
        };
        null !== n && (l.width = n), null !== c && (l.height = c), null !== n && null !== c && o && (l.borderRadius = "50%"), s.push(a.a.createElement("span", {
          key: u,
          className: "".concat(N, " react-loading-skeleton"),
          style: l
        }, "‌"));
      }

      return a.a.createElement("span", null, i ? s.map(function (e, r) {
        return a.a.createElement(i, {
          key: r
        }, e, "‌");
      }) : s);
    }

    function M(e) {
      return (M = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function T() {
      var e = function (e, r) {
        r || (r = e.slice(0));
        return Object.freeze(Object.defineProperties(e, {
          raw: {
            value: Object.freeze(r)
          }
        }));
      }(["\n      .react-loading-skeleton {\n        background-color: ", ";\n        background-image: linear-gradient(\n          90deg,\n          ", ",\n          ", ",\n          ", "\n        );\n      }\n    "]);

      return T = function T() {
        return e;
      }, e;
    }

    function I(e, r) {
      for (var t = 0; t < r.length; t++) {
        var n = r[t];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function W(e, r) {
      return !r || "object" !== M(r) && "function" != typeof r ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : r;
    }

    function q(e) {
      return (q = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function D(e, r) {
      return (D = Object.setPrototypeOf || function (e, r) {
        return e.__proto__ = r, e;
      })(e, r);
    }

    G.defaultProps = {
      count: 1,
      duration: 1.2,
      width: null,
      wrapper: null,
      height: null,
      circle: !1
    };

    var F,
        L,
        B,
        H = function (e) {
      function r() {
        return function (e, r) {
          if (!(e instanceof r)) throw new TypeError("Cannot call a class as a function");
        }(this, r), W(this, q(r).apply(this, arguments));
      }

      var t, n, i;
      return function (e, r) {
        if ("function" != typeof r && null !== r) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(r && r.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), r && D(e, r);
      }(r, e), t = r, (n = [{
        key: "render",
        value: function value() {
          var e = this.props,
              r = e.color,
              t = e.highlightColor,
              n = e.children,
              i = E(T(), r, r, t, r);
          return a.a.createElement("div", {
            className: i
          }, n);
        }
      }]) && I(t.prototype, n), i && I(t, i), r;
    }(n.Component);

    B = {
      color: "#eee",
      highlightColor: "#f5f5f5"
    }, (L = "defaultProps") in (F = H) ? Object.defineProperty(F, L, {
      value: B,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : F[L] = B, t.d(r, "default", function () {
      return G;
    }), t.d(r, "SkeletonTheme", function () {
      return H;
    });
  }]);
});